document.querySelectorAll('.rk-filter-toggle').forEach((button) => {
    button.addEventListener('click', () => {
        button.parentElement.classList.toggle('active');
    });
});

const showMoreBtn = document.querySelector('.rk-show-more-btn');
if (showMoreBtn) {
    showMoreBtn.addEventListener('click', () => {
        const hiddenProducts = document.querySelectorAll('.rk-hidden-product');
        hiddenProducts.forEach((product, index) => {
            if(index < 52){
                product.classList.remove('rk-hidden-product');
            }
        });

        const remainingProducts = document.querySelectorAll('.rk-hidden-product');
        if (remainingProducts.length === 0) {
            showMoreBtn.style.display = 'none';
        }
    });
}

const filterInputs = document.querySelectorAll('.rk-filter-content input');
const productCards = document.querySelectorAll('.rk-product-card');

filterInputs.forEach((input) => {
    input.addEventListener('change', filterProducts);
});

function filterProducts(){
    const activeFilters = [];
    filterInputs.forEach((input) => {
        if(input.checked){
            activeFilters.push(input.value.toLowerCase());
        }
    });

    let visibleCount = 0;
    productCards.forEach((card) => {
        const productTags = card.dataset.tags.toLowerCase();
        const productPrice = parseFloat(card.dataset.price);
        let matched = true;
        activeFilters.forEach((filter) => {
            if(filter === 'under-50'){
                if(productPrice >= 50){
                    matched = false;
                }
            }
            else if(filter === '50-150'){
                if(productPrice < 50 || productPrice > 150){
                    matched = false;
                }
            }
            else if(filter === '150-300'){
                if(productPrice < 150 || productPrice > 300){
                    matched = false;
                }
            }
            else if(filter === 'above-300'){
                if(productPrice <= 300){
                    matched = false;
                }
            }
            else{
                if(!productTags.includes(filter)){
                    matched = false;
                }
            }
        });
        if(matched){
            card.style.display = 'block';
            visibleCount++;
        }else{
            card.style.display = 'none';
        }
    });

    const noProducts = document.querySelector('.rk-no-products');
    if(visibleCount === 0){
        noProducts.style.display = 'block';
    }else{
        noProducts.style.display = 'none';
    }

    if(activeFilters.length > 0){
        showMoreBtn.style.display = 'none';
    }else{
        if(document.querySelectorAll('.rk-hidden-product').length > 0){
            showMoreBtn.style.display = 'inline-block';
        }
    }
}

const mobileFilterBtn = document.querySelector('.rk-mobile-filter-btn');
const filterSidebar = document.querySelector('.collection-filter-sidebar');
const filterOverlay = document.querySelector('.rk-filter-overlay');
const closeFilter = document.querySelector('.rk-close-filter');

if(mobileFilterBtn){

    mobileFilterBtn.addEventListener('click', () => {
        filterSidebar.classList.add('active');
        filterOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    });

    closeFilter.addEventListener('click', closeDrawer);
    filterOverlay.addEventListener('click', closeDrawer);

    function closeDrawer(){
        filterSidebar.classList.remove('active');
        filterOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }
}